"use client";

import { ExecutiveSummarySection } from "@/components/sections/executive-summary";
import { executiveSummary } from "@/lib/data/services-public-figure-communications";

export function ExecutiveSummary() {
  return (
    <ExecutiveSummarySection
      primaryAccent={"var(--color-purple)"}
      eyebrow={executiveSummary.eyebrow}
      title={executiveSummary.title}
      intro={executiveSummary.intro}
      paragraphs={executiveSummary.paragraphs}
      metrics={executiveSummary.metrics}
      cta={executiveSummary.cta}
    />
  );
}
